import {PULLS_INBOX_PATH, PULLS_PATH} from '../constants/routes'
import {stripTrailingSlashes} from './path-helpers'

export const isOnInboxPath = ({pathname}: {pathname: string}) => {
  const normalized = stripTrailingSlashes(pathname)
  return normalized === PULLS_PATH || normalized === PULLS_INBOX_PATH
}
